module.exports = __webpack_public_path__ + "static/media/ckn_reporte.73b714a7.jpg";